/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NameType } from '../../models/name-type';

export interface LogoutCallback$Params {
  state?: NameType;
}

export function logoutCallback(http: HttpClient, rootUrl: string, params?: LogoutCallback$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'errorMessage': NameType;
}>> {
  const rb = new RequestBuilder(rootUrl, logoutCallback.PATH, 'get');
  if (params) {
    rb.query('state', params.state, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'errorMessage': NameType;
      }>;
    })
  );
}

logoutCallback.PATH = '/auth/logout/callback';
